import {
    GETMODULENAMELIST_SUCCESS,
    GETMODULENAMELIST_FAILED,
    RESET_GETMODULENAMELIST,
    LOADING_GETMODULENAMELIST,
    NETWORK_GETMODULENAMELIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetModuleNameList = () => {
    return { type: RESET_GETMODULENAMELIST };
};

const getModuleNameList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMODULENAMELIST });
    await partnerServices
        .post("getModuleNameList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "SUCCESS":
                    dispatch(getModuleNameListsuccess(res.data));
                    break;
                default:
                    dispatch(getModuleNameListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_GETMODULENAMELIST,
                payload: err
            });
        });
};
function getModuleNameListsuccess(data) {
    return {
        type: GETMODULENAMELIST_SUCCESS,
        payload: data
    };
}
function getModuleNameListFailed(data) {
    return {
        type: GETMODULENAMELIST_FAILED,
        payload: data
    };
}

export { resetGetModuleNameList, getModuleNameList };